import React from 'react';

import { H3, Section } from './Layout';
import education from '../images/education.svg';

export default () => {
  return (
    <Section>
      <div>
        <img src={education} alt="Taylor Fuqua Education" />
      </div>
      <div>
        <H3>Education</H3>
        I attended college at The George Washington University, where I competed on the golf team, perfected my above
        average spaghetti recipe and received my Bachelor of Business Administration with a concentration in Information
        Systems. Following undergrad I pursued and received a Master of Science in Information Systems Technology.
      </div>
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/components/Education.js